import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState, createContext } from "react";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import useAuth from "./../hooks/useAuth";
import { useMsg } from "./../hooks/MsgProvider";
import useInformation from "hooks/useInformation";
import { createTheme, ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { useEffect } from "react";
import useSysParam from "hooks/UseSysParam";
import SendEmailPC from "view/pc/forgotPsw/SendEmail.pc";
import SendEmailMobile from "view/mobile/forgotPsw/SendEmail.mobile";
import { forgetPwdSendEmail } from "api";
import RenderPcOrMobile from "./RenderPcOrMobile";
import { getLoginiconsInfo } from "api";

export const LoginViewContext = createContext({});

const schema = yup.object().shape({
	email: yup.string().trim().required(),
});

const theme = (themes) =>
	createTheme({
		...themes,
		components: {
			...themes.components,
			MuiInputBase: {
				styleOverrides: {
					input: {
						padding: 8,
					},
				},
			},
		},
	});

function Login(props) {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [showNewPassword, setShowNewPassword] = useState(false);

	const [isLoading, setIsLoading] = useState(false);
	const [isError, setIsError] = useState(false);
	const { setSuccessMsg, setErrMsg } = useMsg();
	const [showLockTip, setShowLockTip] = useState(false);
	const [lockTipContent, setLockTipContent] = useState("");
	const [backgroundImgList, setBackgroundImgList] = useState([]);
	const [activeBackgroundIndex, setActiveBackgroundIndex] = useState(0);
	const intervalRef = React.useRef();
	const { paramTextValue: logoLink } = useSysParam("sys_logo_hyperlink", true);
	const { paramIntValue: noticeHeight } = useSysParam("important_notice_box_height", true);
	const { paramIntValue: inforHeight } = useSysParam("useful_information_height", true);
	const noticeHeightPx = `${noticeHeight}px`;
	const inforHeightPx = `${inforHeight}px`;
	const [loginRemainTime, setLoginRemainTime] = useState(0);
	const loginIntervalRef = React.useRef();
	const [displayMode, setDisplayMode] = useState("login");
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	const {
		register,
		handleSubmit,
		control,
		formState: { errors },
	} = useForm({
		mode: "onChange",
		resolver: yupResolver(schema),
		defaultValues: {
			email: "",
		},
	});

	const onSubmit = async (data) => {
		setIsLoading(true);
		setLoginRemainTime(5);
		forgetPwdSendEmail({
			userEmail: data.email,
		})
			.then((res) => {
				//console.log("res", res);
				setIsLoading(false);
				setSuccessMsg(res?.data);
			})
			.catch((err) => {
				let isLock = err.response?.data?.isLock;
				setIsLoading(false);
				if (isLock) {
					setShowLockTip(true);
					setLockTipContent(err.response?.data?.message);
				} else {
					setErrMsg(err);
					setIsError(true);
				}
			});
	};

	const usefulInfo = useInformation("USEFUL_INFO", true).informations;
	const iptNotice = useInformation("IPT_NOTICE", true).informations;

	const getBackgroundImage = React.useCallback(() => {
		getLoginiconsInfo()
			.then((res) => {
				const imgsData = res.data.icons;
				setBackgroundImgList(imgsData ?? []);
				if (Array.isArray(imgsData) && imgsData.length > 0) {
					setActiveBackgroundIndex(0);
					clearInterval(intervalRef.current);
					intervalRef.current = setInterval(
						() => {
							setActiveBackgroundIndex((prev) => {
								if (imgsData.length <= prev + 1) {
									return 0;
								}
								return prev + 1;
							});
						},
						res.data.intervalTime * 1000 || 10000
					);
				}
			})
			.catch((err) => {
				if (err) {
					console.log(err);
				}
			});
	}, [backgroundImgList.length]);

	useEffect(() => {
		getBackgroundImage();
	}, [getBackgroundImage]);

	useEffect(() => {
		if (loginRemainTime === 5) {
			clearInterval(loginIntervalRef.current);
			loginIntervalRef.current = setInterval(() => {
				setLoginRemainTime((prev) => prev - 1);
			}, 1000);
		}
		if (loginRemainTime === 0) {
			clearInterval(loginIntervalRef.current);
		}
	}, [loginRemainTime]);

	return (
		<LoginViewContext.Provider
			value={{
				register,
				isLoading,
				theme,
				backgroundImgList,
				noticeHeightPx,
				iptNotice,
				inforHeightPx,
				usefulInfo,
				activeBackgroundIndex,
				logoLink,
				handleSubmit,
				onSubmit,
				control,
				email,
				setEmail,
				errors,
				password,
				setPassword,

				showPassword,
				showLockTip,
				setShowLockTip,
				lockTipContent,
				setErrMsg,
				isError,
				loginRemainTime,
			}}
		>
			<RenderPcOrMobile pc={<SendEmailPC />} mobile={<SendEmailMobile />} />
		</LoginViewContext.Provider>
	);
}
export default Login;
